// Pojedyncze źródło prawdy dla listy lotnisk obsługiwanych przez hub
// „Gdziekolwiek". Używane przez:
//   - src/routes/gdziekolwiek.index.tsx (grid lotnisk na hubie),
//   - src/routes/gdziekolwiek.$from.tsx (sekcja interlinkingu „Z innych lotnisk"),
//   - src/routes/sitemap-anywhere[.]xml.tsx (sitemap dla Google).
// Dzięki temu sitemap nigdy się nie rozjedzie z faktycznie wyrenderowanymi
// landingami i odwrotnie.

export type AnywhereOrigin = {
  code: string;
  label: string;
  sub: string;
};

export const ANYWHERE_ORIGINS: AnywhereOrigin[] = [
  { code: "WAW", label: "Warszawa Chopina", sub: "WAW" },
  { code: "WMI", label: "Warszawa Modlin", sub: "WMI" },
  { code: "KRK", label: "Kraków", sub: "KRK" },
  { code: "GDN", label: "Gdańsk", sub: "GDN" },
  { code: "KTW", label: "Katowice", sub: "KTW" },
  { code: "WRO", label: "Wrocław", sub: "WRO" },
  { code: "POZ", label: "Poznań", sub: "POZ" },
  { code: "SZZ", label: "Szczecin", sub: "SZZ" },
  { code: "RZE", label: "Rzeszów", sub: "RZE" },
  { code: "LCJ", label: "Łódź", sub: "LCJ" },
  { code: "LUZ", label: "Lublin", sub: "LUZ" },
  { code: "BER", label: "Berlin", sub: "BER · opcja dla zachodniej Polski" },
];
